import { inject, Injectable } from '@angular/core';
import type { IInventoryItem, IInventoryShortInfo, StateActionStatus } from '@dev-fast/types';
import { Actions } from '@ngxs/store';
import type { Observable } from 'rxjs';

import { InventoryService } from '@app/core/inventory-service';
import { SellAllItems, SellItemSingle } from '@app/core/state/inventory';
import type { InventoryTooltipEngine } from '@app/shared/components/inventory-tooltip/symbols';
import { actionLoadStatus } from '@app/shared/utils';

@Injectable()
export class InventoryEngineService implements InventoryTooltipEngine {
  readonly #inventoryService = inject(InventoryService);
  readonly #actions = inject(Actions);

  readonly allItems$: Observable<IInventoryItem[]> = this.#inventoryService.allItems$;
  readonly isLoading$: Observable<boolean> = this.#inventoryService.isLoading$;
  readonly actionsDisabled$: Observable<boolean> = this.#inventoryService.actionsDisabled$;
  readonly inventoryShortInfo$: Observable<IInventoryShortInfo> = this.#inventoryService.inventoryShortInfo$;
  readonly itemBeingSold$: Observable<StateActionStatus> = actionLoadStatus(this.#actions, SellItemSingle);
  readonly allItemsBeingSold$: Observable<StateActionStatus> = actionLoadStatus(this.#actions, SellAllItems);

  readonly sellAll = (): Observable<void> => this.#inventoryService.sellAll();
  readonly sellItem = (id: number): Observable<void> => this.#inventoryService.sellItemSingle(id);
}
